"use client";

import { TInquiriesDetailsData } from "@/interfaces";
import SaveBillCard from "./saveBillCard";
import { useState } from "react";
import { BdCloseCircle } from "solar-icon-react/bd";
import { useGetMyBills } from "@/hooks";
import { useSession } from "next-auth/react";

const billLabels: Record<number, string> = {
  60: "قبض آب",
  64: "قبض آب",
  61: "قبض گاز",
  65: "قبض گاز",
  62: "قبض برق",
  63: "قبض برق",
  72: "قبض برق",
  73: "قبض برق",
  67: "قبض تلفن ثابت",
  71: "قبض تلفن ثابت",
  68: "قبض همراه اول",
  69: "قبض ایرانسل",
  70: "قبض رایتل",
};

const SaveBillFromInquiry = ({ data }: { data: TInquiriesDetailsData }) => {
  const [showPrompt, setShowPrompt] = useState(true);
  const [savedInThisView, setSavedInThisView] = useState(false);
  const { data: session } = useSession();
  const token = session?.user.token;
  const { data: savedBillsData, isLoading } = useGetMyBills(token);
  const rawData = data as any;
  const inqueryId = Number(rawData?.inquery_id ?? rawData?.data?.inquery_id);
  const input = rawData?.data?.input || {};
  const response = rawData?.data?.data || {};
  const billId = String(
    input.bill_id || input.billID || response.billID || "",
  ).trim();
  const typeLabel = billLabels[inqueryId];
  const alreadySaved = Boolean(
    savedBillsData?.data?.items?.some(
      (savedBill) => String(savedBill.billId).trim() === billId,
    ),
  );

  if (!typeLabel || !billId || response?.message || !rawData?.id) return null;
  if (!token || isLoading || alreadySaved || savedInThisView) return null;

  const handleSaved = () => {
    setShowPrompt(false);
    setSavedInThisView(true);
  };

  return (
    <>
      {showPrompt && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/45 px-4 py-6 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-label="افزودن قبض به قبض‌های من"
          onClick={() => setShowPrompt(false)}
        >
          <div
            className="relative w-full max-w-2xl"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setShowPrompt(false)}
              className="bg-primary-main absolute top-4 left-4 z-10 flex size-10 items-center justify-center rounded-full text-white shadow-lg transition hover:scale-105"
              aria-label="بستن"
            >
              <BdCloseCircle size={24} />
            </button>
            <SaveBillCard
              purchaseId={rawData.id}
              typeLabel={typeLabel}
              className="mt-0 bg-white! shadow-2xl"
              onSaved={handleSaved}
            />
          </div>
        </div>
      )}
      <SaveBillCard
        purchaseId={rawData.id}
        typeLabel={typeLabel}
        onSaved={handleSaved}
      />
    </>
  );
};

export default SaveBillFromInquiry;
